import { AfterViewInit, Component, ElementRef, OnDestroy } from '@angular/core';
import browserHelper from '@utils/browser-helper';
import { TransitionService } from '@uirouter/angular';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  standalone: false
})
export class TabsComponent implements AfterViewInit, OnDestroy {
  activeItemName: string;
  isMobile = browserHelper.isMobile;
  isOpen = false;
  menuListEl: HTMLUListElement;
  unsubscriber: Function;

  constructor(
    private elRef: ElementRef,
    private transitionService: TransitionService
  ) {}

  ngAfterViewInit() {
    if (this.isMobile) {
      this.menuListEl = this.elRef.nativeElement.querySelector('ul.tabs');
      this.menuListEl.classList.add('dropdown');

      this.setDropdownTitle();
    }

    // Update dropdown title when state changed
    this.unsubscriber = this.transitionService.onSuccess({}, () => {
      this.setDropdownTitle();
    });
  }

  ngOnDestroy() {
    this.unsubscriber();
  }

  private setDropdownTitle() {
    if (!this.isMobile) {
      return;
    }

    setTimeout(() => {
      const activeMenu = this.menuListEl.querySelector('.__active a');
      this.activeItemName = activeMenu?.textContent;
    }, 0);
  }
}
